//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Swiper from 'swiper';

import { listChannelCategories, listMediaTypeTerms, listCurations } from '@/api/channels.js';

export default {
  name: 'ChannelMediaTypeCategories',
  props: {
    heading: String,
    channelId: String,
    mediaType: String,
    type: String,
    titleOnly: {
      type: Boolean,
      default: false,
    },
    hideShowAll: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ChannelsCategoriesListItem: () => import('./ChannelsCategoriesListItem'),
    ProductCardLoader: () => import('@motionelements/core/src/components/product-card/ProductCardLoader.vue'),
  },
  fetchOnServer: true,
  fetchKey() {
    return `${this.channelId}-${this.mediaType}-${this.type}`;
  },
  data() {
    return {
      swiper: null,
      isLoading: false,
      categories: [],
      showAll: false,
      defaultSwiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        autoplay: false,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        enabled: true,
        breakpoints: {
          768: {
            enabled: false,
          },
        },
      },
    };
  },
  async fetch() {
    await this.loadCategories();
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiperAfterLoad();
    });
  },
  beforeDestroy() {
    if (this.swiper && this.swiper.el) {
      this.swiper.destroy();
    }
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    isProduction() {
      return process.env.VUE_APP_ENV === 'production';
    },
    categoriesListItemsCount() {
      const width = this.windowWidth;

      switch (true) {
        case width >= 1600:
          return 10;
        case width >= 992:
          return 8;
        case width >= 768:
          return 6;
        default:
          return 6;
      }
    },
    categoriesFiltered() {
      return this.isProduction && !this.titleOnly && this.type !== 'curations'
        ? this.categories.filter(category => this._.get(category, 'thumbnails[0].url'))
        : this.categories;
    },
    categoriesList() {
      if (this.showAll || this.hideShowAll) {
        return this.categoriesFiltered;
      }
      return this.categoriesFiltered.slice(0, this.categoriesListItemsCount);
    },
    categoriesPageHref() {
      const channelPath = this.$tools.getChannelUrl(this.channelId);
      return this.$link(`${channelPath}/categories`).url();
    },
  },
  methods: {
    initSwiper(swiperOptions = {}) {
      this.swiper = new Swiper(this.$refs.categoriesSwiper, {
        ...this.defaultSwiperOptions,
        ...swiperOptions,
      });
    },
    updateSwiper() {
      if (this.swiper) {
        this.swiper.updateSlides();
      }
    },
    async loadCategories() {
      this.isLoading = true;
      try {
        if (this.type === 'curations') {
          const response = await listCurations('music-channel', {
            per_page: 10,
            'fields[curation]': 'id,heading,background_image,url',
          });
          this.categories = _.get(response, 'data.data', []);
        } else if (this.type === 'instrument') {
          const response = await listMediaTypeTerms(this.channelId);
          this.categories = _.get(response, 'data.data.instruments', []);
        } else {
          const response = await listChannelCategories(this.channelId, {
            per_page: 16,
            media_type: this.mediaType,
            type: this.type,
            'fields[category]': 'id,name,thumbnails,type,url',
          });
          this.categories = _.get(response, 'data.data', []);
        }
      } catch (err) {
        console.warn(err);
        this.categories = [];
      } finally {
        this.isLoading = false;
        if (process.client) {
          this.$nextTick(() => {
            this.initSwiperAfterLoad();
          });
        }
      }
    },
    initSwiperAfterLoad() {
      if (this.swiper && this.swiper.el) {
        this.swiper.destroy();
        this.swiper = null;
      }
      if (!this.$refs.categoriesSwiper || !this.categoriesList.length) {
        return;
      }
      const swiperOptions = this.type === 'curations' ? { centerInsufficientSlides: false } : {};
      this.initSwiper(swiperOptions);
    },
    showAllCategories() {
      this.showAll = true;
      this.$nextTick(() => {
        this.updateSwiper();
      });
    },
    categoryLink(category) {
      if (this.type === 'curations') {
        return category.url;
      }
      return this.$link(`/search/${this.mediaType.replace('_', '-')}`)
        .param(`${this.type}`, category.id)
        .url();
    },
  },
};
